import {
  BarChart3,
  Boxes,
  Building2,
  Cable,
  ClipboardList,
  Headphones,
  LayoutDashboard,
  LifeBuoy,
  PackageSearch,
  Receipt,
  Settings,
  ShoppingBag,
  Store,
  Truck,
  UserCog,
  Users,
  Wallet,
  Warehouse,
  type LucideIcon,
} from 'lucide-react';
import type { Permission, Portal } from '@kts/shared';

/**
 * Navigatsiya reyestri. Yangi bo'lim = bitta element (yo'l, ikonka, ruxsat).
 * Menyuda element faqat foydalanuvchida `perms` dan biri bo'lsa ko'rinadi
 * (server baribir har endpointni tekshiradi).
 *
 * Matn SAQLANMAYDI: bu yerda faqat tarjima KALITI (`app` nom maydoni) turadi,
 * chunki modul darajasidagi massivda hook (`useT`) chaqirib bo'lmaydi.
 * Komponent ichida `t(item.labelKey)` ko'rinishida o'qiladi.
 */
export interface NavItem {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  perms?: Permission[];
  /** Faqat aniq mos kelganda faol (masalan, bosh sahifa). */
  end?: boolean;
}

export interface NavGroup {
  labelKey: string;
  items: NavItem[];
}

export const WORK_NAV: NavGroup[] = [
  {
    labelKey: 'nav.group.main',
    items: [
      { to: '/w', labelKey: 'nav.home', icon: LayoutDashboard, perms: ['dashboard.view'], end: true },
      { to: '/w/analytics', labelKey: 'nav.analytics', icon: BarChart3, perms: ['analytics.view'] },
    ],
  },
  {
    labelKey: 'nav.group.sales',
    items: [
      { to: '/w/orders', labelKey: 'nav.orders', icon: ShoppingBag, perms: ['orders.view'] },
      { to: '/w/sellers', labelKey: 'nav.sellers', icon: Store, perms: ['sellers.view'] },
      { to: '/w/catalog', labelKey: 'nav.catalog', icon: PackageSearch, perms: ['catalog.view'] },
    ],
  },
  {
    labelKey: 'nav.group.operations',
    items: [
      {
        to: '/w/wms',
        labelKey: 'nav.wms',
        icon: Warehouse,
        // Faqat bitta ombor ishi bor xodim ham (masalan ombordan qabul qiluvchi menejer) bo'limga kiradi.
        // `wms.assemble` va `wms.dispatch` bu yerda YO'Q: skan ish o'rinlari faqat ilovada.
        perms: ['wms.view', 'supplies.view', 'wms.handover', 'wms.receive'],
      },
      { to: '/w/delivery', labelKey: 'nav.delivery', icon: Truck, perms: ['delivery.view', 'delivery.courier'] },
    ],
  },
  {
    labelKey: 'nav.group.finance',
    items: [
      { to: '/w/finance', labelKey: 'nav.finance', icon: Wallet, perms: ['finance.view', 'finance.cash'] },
      { to: '/w/fiscal', labelKey: 'nav.fiscal', icon: Receipt, perms: ['finance.fiscal.view'] },
    ],
  },
  {
    labelKey: 'nav.group.team',
    items: [
      { to: '/w/hr', labelKey: 'nav.hr', icon: Users, perms: ['hr.view', 'hr.attendance.view'] },
      { to: '/w/support', labelKey: 'nav.support', icon: Headphones, perms: ['support.chats'] },
    ],
  },
  {
    labelKey: 'nav.group.system',
    items: [
      { to: '/w/integrations', labelKey: 'nav.integrations', icon: Cable, perms: ['integrations.view'] },
      { to: '/w/users', labelKey: 'nav.users', icon: UserCog, perms: ['users.view', 'roles.manage'] },
      { to: '/w/settings', labelKey: 'nav.settings', icon: Settings, perms: ['settings.manage', 'branches.manage', 'tariffs.manage', 'audit.view'] },
    ],
  },
];

export const SELLER_NAV: NavGroup[] = [
  {
    labelKey: 'nav.group.main',
    items: [
      { to: '/s', labelKey: 'nav.home', icon: LayoutDashboard, perms: ['dashboard.view'], end: true },
      { to: '/s/analytics', labelKey: 'nav.analytics', icon: BarChart3, perms: ['analytics.view'] },
    ],
  },
  {
    labelKey: 'nav.group.sales',
    items: [
      { to: '/s/products', labelKey: 'nav.products', icon: PackageSearch, perms: ['catalog.view'] },
      { to: '/s/stock', labelKey: 'nav.stock', icon: Boxes, perms: ['stock.view'] },
      { to: '/s/supplies', labelKey: 'nav.supplies', icon: ClipboardList, perms: ['supplies.view'] },
      { to: '/s/orders', labelKey: 'nav.orders', icon: ShoppingBag, perms: ['orders.view'] },
    ],
  },
  {
    labelKey: 'nav.group.account',
    items: [
      { to: '/s/finance', labelKey: 'nav.finance', icon: Wallet, perms: ['finance.view'] },
      { to: '/s/integrations', labelKey: 'nav.integrations', icon: Cable, perms: ['integrations.view'] },
      { to: '/s/support', labelKey: 'nav.help', icon: LifeBuoy, perms: ['support.tickets'] },
    ],
  },
  {
    labelKey: 'nav.group.company',
    items: [
      { to: '/s/company', labelKey: 'nav.company', icon: Building2, perms: ['company.manage'] },
      { to: '/s/team', labelKey: 'nav.team', icon: Users, perms: ['team.manage'] },
    ],
  },
];

export const navFor = (portal: Portal) => (portal === 'work' ? WORK_NAV : SELLER_NAV);
export const portalHome = (portal: Portal) => (portal === 'work' ? '/w' : '/s');
